<mat-dialog-content>
  <img [src]="Src">
</mat-dialog-content>
